const ADMIN_DASHBOARD = '/admin-dashboard';
const APPLICATION = '/program/:id/application';
const COMMUNITY = '/community';
const COMMUNITY_PROFILE = '/community/:profileId';
const COMMUNITY_SETTINGS = '/community/:profileId/settings';
const DASHBOARD = '/programs-section/:slug';
const ENTREPRENEUR_MATCHING = '/program/:id/matching';
const EXECUTIVE_SUMMARY = '/executive-summary/:projectId/:step';
const LOGIN = '/login';
const MAINTENANCE = '/maintenance';
const MENTOR_MATCHING = '/mentor-matching/:id/explore';
const MY_VENTURE = '/venture/:id/workspace';
const PROFILE = '/profile';
const RESET_PASSWORD = '/reset-password';
const ROOT = '/';
const SETTINGS = '/settings';
const SIGNUP = '/signup';
const TOOLS = '/tools/:projectId/:slug/*';
const TROUBLESHOOT = '/troubleshoot';
const VENTURE = '/venture/:id/*';
const VENTURE_SUMMARY = '/venture/:projectId/venture-summary';
const VERIFY_EMAIL = '/verify-email';
const VERIFY_EMAIL_TOKEN = '/verify-email/:token';

// MANAGEMENT_PANEL
const MANAGEMENT_PANEL_BASE = '/management-panel/:programId';
const MANAGEMENT_PANEL_STAGE = '/management-panel/:programId/:stage/:userType';
const MANAGEMENT_PANEL_STAGE_INVITES = '/management-panel/:programId/matching/invites';
const MANAGEMENT_PANEL_RANKING_AND_MATCHES =
  '/management-panel/:programId/matching/ranking-&-matches';
const MANAGEMENT_PANEL_RANKING_AND_MATCHES_DETAILS =
  '/management-panel/:programId/matching/ranking-&-matches/:applicationId';
const MANAGEMENT_PANEL_EMAIL_DASHBOARD = '/management-panel/:programId/email-dashboard/:userType';
const MANAGEMENT_PANEL_PROGRAM_HEALTH = '/management-panel/:programId/program-health';
const MANAGEMENT_PANEL_PROGRAM_SETUP = '/management-panel/:programId/program-setup/:section';

export const STAGES = {
  application: 'application',
  selection: 'selection',
  approved: 'approved',
  matching: 'matching',
  incubating: 'incubating',
  alumni: 'alumni',
  rejected: 'rejected',
  dropped: 'dropped',
};

export const PROGRAM_SETUP_SECTIONS = {
  profile: 'profile',
  applicationStage: 'application-stage',
  matchingStage: 'matching-stage',
  incubationStage: 'incubation-stage',
  contentCustomization: 'content-customization',
};

export const USER_TYPES = {
  projects: 'projects',
  mentors: 'mentors',
};

export {
  ADMIN_DASHBOARD,
  APPLICATION,
  COMMUNITY_PROFILE,
  COMMUNITY_SETTINGS,
  COMMUNITY,
  DASHBOARD,
  ENTREPRENEUR_MATCHING,
  EXECUTIVE_SUMMARY,
  LOGIN,
  MAINTENANCE,
  MANAGEMENT_PANEL_BASE,
  MANAGEMENT_PANEL_EMAIL_DASHBOARD,
  MANAGEMENT_PANEL_PROGRAM_HEALTH,
  MANAGEMENT_PANEL_PROGRAM_SETUP,
  MANAGEMENT_PANEL_RANKING_AND_MATCHES_DETAILS,
  MANAGEMENT_PANEL_RANKING_AND_MATCHES,
  MANAGEMENT_PANEL_STAGE_INVITES,
  MANAGEMENT_PANEL_STAGE,
  MENTOR_MATCHING,
  MY_VENTURE,
  PROFILE,
  RESET_PASSWORD,
  ROOT,
  SETTINGS,
  SIGNUP,
  TOOLS,
  TROUBLESHOOT,
  VENTURE_SUMMARY,
  VENTURE,
  VERIFY_EMAIL_TOKEN,
  VERIFY_EMAIL,
};
